// @ts-nocheck
/* FORM REGISTER */

import { apiService } from "../services/api";
import Bouncer from "formbouncerjs";
import moment from "moment";
const emails: string[] = [
  "temp-mail.org",
  "correotemporal.org",
  "mohmal.com",
  "yopmail.com",
  "tempail.com",
  "emailondeck.com",
  "emailtemporalgratis.com",
  "crazymailing.com",
  "tempr.email",
  "bupmail.com",
  "guerrillamail.com",
  "temp-mail.io",
  "es.emailfake.com",
  "nowmymail.com",
  "10minutemail.net",
  "es.getairmail.com",
  "mailf5.com",
  "flashmail.it",
  "10minemail.com",
  "mailcatch.com",
  "temp-mails.com",
  "spambox.us",
  "mailnull.com",
  "incognitomail.com",
  "ssl.trashmail.net",
  "trashmail.net",
  "mailinator.com",
  "tempinbox.com",
  "filzmail.com",
  "dropmail.me",
  "spam4.me",
  "cs.email",
  "one-off.email",
  "throwawaymail.com",
  "emailtemporal.org",
  "maildrop.cc",
  "mailforspam.com",
  "trashmail.com",
  "teleworm.us",
  "superrito.com",
  "rhyta.com",
  "jourrapide.com",
  "gustr.com",
  "fleckens.hu",
  "einrot.com",
  "cuvox.de",
  "dayrep.com",
  "muyoc.com",
  "buxod.com",
  "pidox.org",
  "mecip.net",
  "pudxe.com",
  "xedmi.com",
  "ludxc.com",
  "juzab.com",
  "klepf.com",
  "matra.site",
  "bombamail.icu",
  "yermail.net",
  "totallynotfake.net",
  "techblast.ch",
  "spamthis.network",
  "spammy.host",
  "spammer.fail",
  "shadap.org",
  "pewpewpewpew.pw",
  "netcom.ws",
  "itcompu.com",
  "disposable.site",
  "deinbox.com",
  "sharklasers.com",
  "guerrillamailblock.com",
  "guerrillamail.org",
  "guerrillamail.net",
  "guerrillamail.de",
  "guerrillamail.biz",
  "grr.la",
  "netmail.tk",
  "laste.ml",
  "firste.ml",
  "zeroe.ml",
  "supere.ml",
  "emlhub.com",
  "emlpro.com",
  "emltmp.com",
  "yomail.info",
  "10mail.org",
  "wegwerfmail.org",
  "wegwerfmail.net",
  "wegwerfmail.de",
  "trashmail.me",
  "trashmail.io",
  "trashmail.at",
  "trash-mail.at",
  "rcpt.at",
  "proxymail.eu",
  "objectmail.com",
  "kurzepost.de",
  "damnthespam.com",
  "contbay.com",
  "0box.eu",
  "marmaryta.space",
  "5y5u.com",
  "58as.com",
  "firemailbox.club",
  "mozej.com",
  "mailna.co",
  "mailna.in",
  "mailna.me",
  "mohmal.im",
  "mohmal.in",
  "yopmail.fr",
  "yopmail.net",
  "cool.fr.nf",
  "jetable.fr.nf",
  "nospam.ze.tc",
  "nomail.xl.cx",
  "mega.zik.dj",
  "speed.1s.fr",
  "courriel.fr.nf",
  "moncourrier.fr.nf",
  "monemail.fr.nf",
  "monmail.fr.nf",
  "nedoz.com",
  "nmagazinec.com",
  "armyspy.com",
  "vmani.com",
  "discard.email",
  "discardmail.com",
  "discardmail.de",
  "spambog.com",
  "spambog.de",
  "spambog.ru",
  "0btcmail.pw",
  "815.ru",
  "knol-power.nl",
  "hartbot.de",
  "freundin.ru",
  "smashmail.de",
  "s0ny.net",
  "pecinan.net",
  "budaya-tionghoa.com",
  "lajoska.pe.hu",
  "1mail.x24hr.com",
  "from.onmypc.info",
  "now.mefound.com",
  "mowgli.jungleheart.com",
  "yourspamgoesto.space",
  "pecinan.org",
  "budayationghoa.com",
  "CR.cloudns.asia",
  "TLS.cloudns.asia",
  "MSFT.cloudns.asia",
  "B.cr.cloUdnS.asia",
  "ssl.tls.cloudns.ASIA",
  "sweetxxx.de",
  "DVD.dns-cloud.net",
  "DVD.dnsabr.com",
  "BD.dns-cloud.net",
  "YX.dns-cloud.net",
  "SHIT.dns-cloud.net",
  "SHIT.dnsabr.com",
  "eu.dns-cloud.net",
  "eu.dnsabr.com",
  "asia.dnsabr.com",
  "8.dnsabr.com",
  "pw.8.dnsabr.com",
  "mm.8.dnsabr.com",
  "23.8.dnsabr.com",
  "pecinan.com",
  "disposable-email.ml",
  "pw.epac.to",
  "postheo.de",
  "sexy.camdvr.org",
  "Disposable.ml",
  "888.dnS-clouD.NET",
  "adult-work.info",
  "casinokun.hu",
  "bangsat.in",
  "wallus.casinokun.hu",
  "trap-mail.de",
  "umailz.com",
  "panchoalts.com",
  "gmaile.design",
  "ersatzauto.ch",
  "tempes.gq",
  "cpmail.life",
  "tempemail.info",
  "coolmailcool.com",
  "kittenemail.com",
  "99email.xyz",
  "notmyemail.tech",
  "m.cloudns.cl",
  "twitter-sign-in.cf",
  "anonymized.org",
  "you.has.dating",
  "ketoblazepro.com",
  "kost.party",
  "0hio0ak.com",
  "4dentalsolutions.com",
  "t.woeishyang.com",
  "ondemandemail.top",
  "kittenemail.xyz",
  "blackturtle.xyz",
  "y.x.ssl.cloudns.asia",
  "geneseeit.com",
  "mailg.ml",
  "media.motornation.buzz",
  "sage.speedfocus.biz",
  "badlion.co.uk",
  "safeemail.xyz",
  "virtual-generations.com",
  "new-york.host",
  "mrdeeps.ml",
  "kitela.work",
  "fouadps.cf",
  "megacorp.work",
  "fake-wegwerf.email",
  "tigytech.com",
  "historictheology.com",
  "ma.567map.xyz",
  "hotmailproduct.com",
  "maxsize.online",
  "happyfreshdrink.com",
  "denomla.com",
  "pansamantala.poistaa.com",
  "sahaltastari.sytes.net",
  "cecep.ddnsking.com",
  "fadilmalik.ddnsking.com",
  "csingi.sytes.net",
  "richmail.ga",
  "tikmail.gq",
  "bupkiss.ml",
  "guerrillamail.info",
  "pokemail.net",
  "myinbox.icu",
  "just4fun.me",
  "inscriptio.in",
  "cloud-mail.top",
  "safemail.icu",
  "montokop.pw",
  "tempamailbox.info",
  "blogtron.com",
  "atanetorg.org",
  "aristockphoto.com",
  "jomcs.com",
  "kukuka.org",
  "gothill.com",
  "mixely.com",
  "marsoasis.org",
  "walmarteshop.com",
  "outlandlabs.com",
  "comectrix.com",
  "buymondo.com",
  "eventao.com",
  "louieliu.com",
  "mymailnow.xyz",
  "cuoly.com",
  "getnada.com",
  "abyssmail.com",
  "boximail.com",
  "clrmail.com",
  "dropjar.com",
  "getairmail.com",
  "givmail.com",
  "inboxbear.com",
  "robot-mail.com",
  "tafmail.com",
  "vomoto.com",
  "zetmail.com",
];

const api = new apiService();

declare global {
  interface Window {
    showLogin: any;
    showSignIn: any;
    dataLayer: any;
    CryptoJS: any;
  }
}

export const formregister = (): void => {
  var validateFormBouncer = Bouncer("#do-presidente-core-user-validate", {
    disableSubmit: true,
    patterns: {
      email:
        /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
    },
    customValidations: {
      emailVerified: function (field: any) {
        let array_email = field.value.split("@");
        const res = emails.find((m) => m === array_email[1]);
        return res === undefined ? false : true;
      },
      emailValid: function (field: any) {
        const res = field.value.indexOf("+");
        return res === -1 ? false : true;
      },
    },
    messages: {
      missingValue: {
        default: "Campo Obligatorio",
      },
      emailVerified: "Por favor ingrese un email válido",
      emailValid: "Por favor ingrese un email válido",
      patternMismatch: {
        email: "Por favor ingrese un email válido",
      },
    },
  }) as any;

  let validateForm = document.querySelector(
    "#do-presidente-core-user-validate"
  );
  if (validateForm) {
    validateForm.addEventListener(
      "bouncerFormValid",
      function (event) {
        let emailCont = document.querySelector(
          ".input_validate_mail"
        ) as HTMLInputElement;
        console.log('validando')
        validateUser(emailCont.value, localStorage.openLoginLocation ?? 'na');
      },
      false
    );
  }

  const editDay: HTMLSelectElement = document.getElementById("edit-day") as any;

  var registerFormBouncer = Bouncer("#do-presidente-core-user-register", {
    disableSubmit: true,
    patterns: {
      email:
        /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
      name: /^[A-Za-z]+$/,
      lastname: /^[A-Za-z]+$/,
    },
    customValidations: {
      emailVerified: function (field: any) {
        let array_email = field.value.split("@");
        const res = emails.find((m) => m === array_email[1]);
        return res === undefined ? false : true;
      },
      emailValid: function (field: any) {
        const res = field.value.indexOf("+");
        return res === -1 ? false : true;
      },
      onlyWords: function (field: any) {
        if (field.name == "name" || field.name == "lastname") {
          const res = /^[a-zA-Z\u00C0-\u017F\s]+$/.test(field.value);
          return res ? false : true;
        }
      },
      onlyNumbers: function (field: any) {
        if (field.name == "phone") {
          const res = /^[0-9]+$/.test(field.value);
          return res ? false : true;
        }
      },
      phoneVerified: function (field: any) {
        if (field.name == "phone") {
          const value = field.value;
          if (value.length < 10 || value.length > 10) {
            return true;
          }
        }
      },
      dniVerified: function (field: any) {
        if (field.name == 'dni') {
          const value = field.value
          if (value.length < 7 || value.length > 11) {
            return true;
          }
          //  const res = /^[0-9]+$/.test(field.value);
          //  return res ? false : true;
        }
      },
      password: function (field: any) {
        if (field.name === "passconfirm[pass2]") {
          let contraseña = document.getElementById(
            "edit-passconfirm-pass1"
          ) as any;
          if (field.value != contraseña.value) {
            return true;
          }
          return false;
        }
      },
      ageVerified: function (field: any) {
        if (field.name === "day") {
          let year = document.getElementById("edit-year") as any;
          let month = document.getElementById("edit-month") as any;
          let day = document.getElementById("edit-day") as any;
          year = year.value;
          month = month.value;
          day = day.value;
          const response = getAge(year, month, day);
          if (response < 18) {
            if (editDay) {
              editDay.classList.add("error-edad");
              return true;
            }
          }
          return false;
        }
      },
    },
    messages: {
      missingValue: {
        checkbox:
          "Debes aceptar Términos y condiciones y Políticas de privacidad",
        default: "Campo Obligatorio",
      },
      emailVerified: "Por favor ingrese un email válido",
      emailValid: "Por favor ingrese un email válido",
      onlyWords: "No se permiten números",
      onlyLetters: "Solo se permiten letras",
      onlyNumbers: "Solo se permiten números",
      phoneVerified: "Por favor ingrese un número de teléfono válido",
      dniVerified: 'Por favor ingrese un DNI válido',
      ageVerified: "Debe ser mayor de edad",
      password: "Contraseñas no coinciden",
      patternMismatch: {
        email: "Por favor ingrese un email válido",
      },
    },
    messageAfterField: true,
  }) as any;

  let registerForm: HTMLFormElement = document.querySelector(
    "#do-presidente-core-user-register"
  ) as any;
  let flagSend = true;
  if (registerForm) {
    registerForm.addEventListener(
      "bouncerFormValid",
      async function (event) {
        const mail: HTMLInputElement = registerForm.querySelector(
          "#edit-mail"
        ) as any;

        if (flagSend) {
          const resMail = await api.validateUser({
            mail: mail.value,
            lastlogin:  localStorage.openLoginLocation ?? 'NA',
          });
        }

        const mailBox = HTMLElement = registerForm.querySelector('.js-form-item-mail')

        const mailError: HTMLInputElement = registerForm.querySelector(
          ".error-mail"
        ) as any;
        mail.addEventListener("keydown", function () {
          mailError?.textContent = "";
          // console.log("entra");
        });

        if (resMail) {
          let mailError = document.querySelector('.error-message.error-mail');
          if(mailError) {
            mailError.innerHTML = "El correo ya se encuentra registrado"
          }
          else {
            //console.log("resphone", resPhone)
            let error = document.createElement('div')
            error.className = 'error-message error-mail'
            error.innerHTML = "El correo ya se encuentra registrado"
            mailBox.appendChild(error)
            mail.addEventListener('keydown', e => {
              error.innerHTML = ''
            })
          }
          //mailError?.textContent = "El correo ya se encuentra registrado";
          document.querySelector(".container__scroll").scrollTop = 0;
          return;
        } else {
          //error.innerHTML = ''
          //mailError?.textContent = "";
        }

        const dni: HTMLInputElement = registerForm.querySelector(
          "#edit-dni"
        ) as any;
        const DNIError: HTMLInputElement = registerForm.querySelector(
          ".error-dni"
        ) as any;
        const dniBox: HTMLInputElement = registerForm.querySelector(
          ".js-form-item-dni"
        ) as any;
        if (flagSend) {
          const resDNI = await api.validateUserDni({
            dni: dni.value,
          });
        }

        dni.addEventListener("keydown", function () {
          DNIError?.textContent = "";
          // console.log("entra");
        });

        if (resDNI) {
          let dniError = document.querySelector('.error-message.error-dni');
          if(dniError) {
            dniError.innerHTML = "El DNI ya se encuentra registrado"
          }
          else {
            //console.log("resphone", resPhone)
            let error = document.createElement('div')
            error.className = 'error-message error-dni'
            error.innerHTML = "El DNI ya se encuentra registrado"
            dniBox.appendChild(error)
            // dni.addEventListener('keydown', e => {
            //   error.innerHTML = ''
            // })
          }

          //DNIError?.textContent = "El DNI ya se encuentra registrado";
          document.querySelector(".container__scroll").scrollTop = 0;
          return;
        } else {
          //error.innerHTML = ''
          //DNIError?.textContent = "";
        }

        const phone: HTMLInputElement = registerForm.querySelector(
          "#edit-phone"
        ) as any;
        const phoneBox: HTMLElement = registerForm.querySelector(
          ".js-form-item-phone"
        ) as any;
        const phoneError: HTMLInputElement = registerForm.querySelector(
          ".error-phone"
        ) as any;

        if (flagSend) {
          const resPhone = await api.validateUserPhone({
            phone: phone.value,
          });
        }

        phone.addEventListener("keydown", function () {
          phoneError?.innerHTML = "";
        });

        if (resPhone) {
          let phoneError = document.querySelector('.error-message.error-phone');
          if(phoneError) {
            phoneError.innerHTML = "El teléfono ya se encuentra registrado"
          }
          else {
            //console.log("resphone", resPhone)
            let error = document.createElement('div')
            error.className = 'error-message error-phone'
            error.innerHTML = "El teléfono ya se encuentra registrado"
            phoneBox.appendChild(error)
          }

          phone.addEventListener('keydown', e => {
            let phoneError = document.querySelector('.error-message.error-phone');
            if(phoneError) phoneError.innerHTML = ''
          })
          //phoneError?.textContent = "El teléfono ya se encuentra registrado";
          document.querySelector(".container__scroll").scrollTop = 0;
          return;
        }

        // const { default: moment } = await import('moment')

        const day: HTMLInputElement = registerForm.querySelector(
          "#edit-day"
        ) as any;
        const month: HTMLInputElement = registerForm.querySelector(
          "#edit-month"
        ) as any;
        const year: HTMLInputElement = registerForm.querySelector(
          "#edit-year"
        ) as any;
        const DateError: HTMLInputElement = registerForm.querySelector(
          ".error-date"
        ) as any;

        editDay.addEventListener("change", function () {
          DateError?.textContent = "";
        });

        if (getAge(year.value, month.value, day.value) <= 17) {
          DateError?.textContent = "Debe ser mayor de edad";
          document.querySelector(".container__scroll").scrollTop = 0;
          return;
        } else if (
          !moment(
            day.value + "-" + month.value + "-" + year.value,
            "D-M-YYYY"
          ).isValid()
        ) {
          DateError?.textContent = "";
          DateError?.textContent = "No es una fecha valida";
          document.querySelector(".container__scroll").scrollTop = 0;
          return;
        }

        if (flagSend) {
          flagSend = false;
          registerForm.submit();
          registerForm.removeEventListener('submit', () => {})
          registerForm.removeEventListener('bouncerFormValid', () => {})
        }

        const emailForm: HTMLInputElement = registerForm.querySelector(
          "#edit-mail"
        ) as any;
      },
      false
    );

    //dataLayer fotmRegister button
    const btnForm = registerForm.querySelector("#edit-submit") as any;
    const emailForm: HTMLInputElement = registerForm.querySelector(
      "#edit-mail"
    ) as any;
    // btnForm.addEventListener("click", (e: any) => {
    //   window.dataLayer.push({
    //     event: "GAEvent",
    //     event_category: "Register", // Categoría del evento (String). Requerido.
    //     event_action: "Sucess", // Acción o subcategoría del evento (String). Requerido.
    //     event_label: "LoginAPI",
    //     userUid: window.CryptoJS.SHA256(emailForm.value).toString(
    //       window.CryptoJS.enc.Hex
    //     ), // Etiqueta de descripción del evento (String). Requerido.
    //   });
    // });
  }

  function getAge(y: any, m: any, d: any) {
    var today = new Date();
    var birthDate = new Date(`${y}/${m}/${d}`);
    var age = (today.getFullYear() - birthDate.getFullYear()) as any;
    var m = (today.getMonth() - birthDate.getMonth()) as any;
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  async function validateUser(mail: any, location_login: any = '') {
    (await api.validateUser({
      mail: mail,
      lastlogin: location_login,
    }))
      ? window.showLogin(mail)
      : window.showSignIn(mail);
  }
};
